interface IscOfflineBannerProps {
  offline: boolean;
  checking: boolean;
  onRecheck: () => void;
}

export function IscOfflineBanner({ offline, checking, onRecheck }: IscOfflineBannerProps) {
  if (!offline) return null;

  return (
    <div
      className="ph-isc-offline-banner alert alert-warning py-2 px-3 mb-0 rounded-0 border-0 border-bottom"
      role="status"
    >
      <div className="ph-isc-offline-banner__inner d-flex flex-wrap align-items-center justify-content-between gap-2">
        <span className="small mb-0">
          API stock ISC hors ligne — réservations, sorties stock et alertes peuvent être
          indisponibles.
        </span>
        <button
          type="button"
          className="btn btn-sm btn-outline-dark"
          disabled={checking}
          onClick={() => void onRecheck()}
        >
          {checking ? "Vérification…" : "Réessayer"}
        </button>
      </div>
    </div>
  );
}
